import type { JSX } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/** Single-line search box for list toolbars. Matching happens in `useTableFilters`. */
export function SearchInput({
  value,
  onChange,
  placeholder = 'Search…',
}: SearchInputProps): JSX.Element {
  return (
    <div className="relative flex-1">
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
      />
      <Input
        type="search"
        aria-label="Search"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="pl-9"
      />
    </div>
  );
}
